import type { MemberSettings } from '../@models/member-settings';

export const DEFAULT_MEMBER_SETTINGS: Omit<
  MemberSettings,
  'shopId' | 'createdAt' | 'updatedAt' | 'updatedBy'
> = {
  schemaVersion: 1,
  version: 1,
  invitations: {
    enabled: true,
    defaultRole: 'member',
    requireVerifiedEmail: true,
    expirationDays: 7,
  },
  onboarding: {
    requireProfileReview: true,
    requireServiceAssignment: true,
    requireScheduleSetup: true,
    requireBookingSetup: true,
  },
  defaults: {
    role: 'member',
    bookingEnabled: false,
    visibleOnPublicProfile: false,
  },
  scheduling: {
    requireMemberSchedule: true,
    allowMembersToManageOwnSchedule: true,
    allowMembersToRequestTimeOff: true,
    timeOffRequiresApproval: true,
  },
  services: {
    requireExplicitServiceAssignment: true,
    allowMembersToManageOwnServices: false,
  },
  profile: {
    allowMembersToManageShopTitle: false,
    allowMembersToManagePublicVisibility: false,
  },
  permissions: {
    allowRoleOverrides: true,
    allowPermissionOverrides: false,
  },
  lifecycle: {
    preserveHistoryOnRemoval: true,
    allowRehire: true,
  },
};

export function normalizeMemberSettings(
  shopId: string,
  value?: Partial<MemberSettings>,
): MemberSettings {
  const settings = value ?? {};
  return {
    ...DEFAULT_MEMBER_SETTINGS,
    ...settings,
    shopId,
    onboarding: { ...DEFAULT_MEMBER_SETTINGS.onboarding, ...settings.onboarding },
    defaults: { ...DEFAULT_MEMBER_SETTINGS.defaults, ...settings.defaults },
    scheduling: { ...DEFAULT_MEMBER_SETTINGS.scheduling, ...settings.scheduling },
    services: { ...DEFAULT_MEMBER_SETTINGS.services, ...settings.services },
    profile: { ...DEFAULT_MEMBER_SETTINGS.profile, ...settings.profile },
    lifecycle: {
      ...DEFAULT_MEMBER_SETTINGS.lifecycle,
      ...settings.lifecycle,
      preserveHistoryOnRemoval: true,
    },
    invitations: {
      ...DEFAULT_MEMBER_SETTINGS.invitations,
      ...settings.invitations,
      requireVerifiedEmail: true,
    },
    permissions: {
      ...DEFAULT_MEMBER_SETTINGS.permissions,
      ...settings.permissions,
      allowPermissionOverrides: false,
    },
  } as MemberSettings;
}
